var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddressBookNotebookIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.625,
    height: 22,
    viewBox: "0 0 20.625 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_8664793_address_book_notebook_icon",
    "data-name": "8664793_address_book_notebook_icon",
    d: "M42.313,12.375h-2.75a3.437,3.437,0,0,0-3.437,3.438.69.69,0,0,0,.688.688h8.25a.688.688,0,0,0,.688-.687A3.437,3.437,0,0,0,42.313,12.375ZM40.938,11a2.75,2.75,0,1,0-2.75-2.75A2.75,2.75,0,0,0,40.938,11Zm11,2.75H51.25v4.125h.688a.688.688,0,0,0,.688-.687v-2.75A.69.69,0,0,0,51.937,13.75Zm0-11H51.25V6.875h.688a.69.69,0,0,0,.688-.687V3.438A.688.688,0,0,0,51.937,2.75Zm0,5.5H51.25v4.125h.688a.69.69,0,0,0,.688-.687V8.938A.69.69,0,0,0,51.937,8.25ZM47.125,0H34.75A2.75,2.75,0,0,0,32,2.75v16.5A2.75,2.75,0,0,0,34.75,22H47.125a2.75,2.75,0,0,0,2.75-2.75V2.75A2.751,2.751,0,0,0,47.125,0Zm.687,19.25a.688.688,0,0,1-.687.688H34.75a.688.688,0,0,1-.687-.687V2.75a.687.687,0,0,1,.688-.687H47.125a.687.687,0,0,1,.687.688Z",
    transform: "translate(-32)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressBookNotebookIcon);
export default __webpack_public_path__ + "static/media/address_book_notebook_icon.807ca5e48359cc52490a2f79d5e02cd2.svg";
export { ForwardRef as ReactComponent };